import { IMMUTABLE_GAME_ID } from "@/constants";
import type { Quest } from "@ui-kit/QuestList";

export const globalTelegramQuest: Quest = {
  type: "custom",
  key: "telegram-bot-connect",
  label: "Telegram Bot Connect",
  caption: "Connect your Telegram account",
  increase: 25,
  badgeIcon: "ImxRewards",
  badgeTemplate: "+<increase> <icon> Gems",
  eventId: `${IMMUTABLE_GAME_ID}-telegram-bot-connect-event`,
  ruleId: `${IMMUTABLE_GAME_ID}-telegram-bot-connect`,
  icon: "Telegram",
};
